import { render, staticRenderFns } from "./metabaseDashboardLink.vue?vue&type=template&id=66d835d1"
import script from "./metabaseDashboardLink.vue?vue&type=script&lang=js"
export * from "./metabaseDashboardLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports